

















import { Component, mixins, Prop } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
import ComponentHeaderWithLink from '~/components/header/header-with-link.vue'
import { IArticle } from '~/assets/interfaces/articles'
import ComponentArticleItem from '~/components/articles/article-item.vue'
import { COLLECTIONS_PATH } from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'

@Component({
  components: {
    ComponentArticleItem,
    ComponentHeaderWithLink,
  },
  filters: {
    filterUrl,
  },
})
export default class ComponentPageIndexCollectionsContent extends mixins(
  MixinGeneral
) {
  @Prop({ type: Array, default: () => [] }) readonly items!: IArticle[]
  @Prop({ type: String, default: '' }) readonly title!: string

  private COLLECTIONS_PATH = COLLECTIONS_PATH
}
